/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { Card, Box, Typography } from "@mui/material";
import { cardStyle, contentTopStyle, metaStyle, textHeadingStyle } from "./utils";

const GalleryCard = (props) => {
    
    const { model, children, selectModel } = props || {};
    // const sampleImage = {url: 'https://local.simplicitycms.ca:3300/static/media/logo-white-full-b.1cb69a21329ff04681c7.svg'}
    
    return (
        <Fragment>
            {model && (
                <Card
                    style={cardStyle}
                    onClick={(event) => selectModel(event, model)}
                >
                    {/*<CardMedia*/}
                    {/*    component='div'*/}
                    {/*    classes={mediaStyles}*/}
                    {/*    // style={{backgroundColor: '#003E43'}}*/}
                    {/*    height={height}*/}
                    {/*    // src={sampleImage && sampleImage.url}*/}
                    {/*/>*/}
                    <Box py={1} px={1} style={contentTopStyle}>
                        {children}
                    </Box>
                    <Box py={4} px={1}>
                        <Box style={metaStyle}>
                            <Typography variant='h5' style={textHeadingStyle}>
                                {model && model.title}
                            </Typography>
                            <Typography variant='h5' style={textHeadingStyle}>
                                {model && model.type}
                            </Typography>
                        </Box>
                    </Box>
                </Card>
            )}
        </Fragment>
    );
};

export default GalleryCard;
